"use client";

// Fehlerzustand des oeffentlichen Formulars: freundlich, ohne Technik,
// mit dem Hinweis, dass nichts verloren ist (der Entwurf liegt im Browser).
import { useEffect } from "react";
import { TriangleAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/empty-state";

export default function FormularFehler({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);
  return (
    <div className="mx-auto max-w-2xl px-4 pt-20">
      <EmptyState
        icon={TriangleAlert}
        title="Das Formular ließ sich nicht laden"
        description="Bitte versuche es gleich noch einmal. Was du schon eingegeben hast, bleibt auf diesem Gerät gespeichert."
        action={<Button onClick={reset}>Noch einmal</Button>}
      />
    </div>
  );
}
